const stjude = {
  $ready: [],
  digitalData: {
    sysEnv: {
      siteCode: "playlive",
      environment: import.meta.env.VITE_APP_ENV,
    },
    page: {
      path: "",
      pageName: "", //please pass unique page name for each page
      language: "english",
      eventCode: "",
    },
    user: {
      userName: localStorage.getItem("tiltifyUsername") ?? "anonymous",
      campaignName: localStorage.getItem("tiltifyCampaignName") ?? undefined,
      userTwitchname: localStorage.getItem("twitchUsername") ?? undefined,
    },
    event: [],
  },
};

window.stjude = stjude;

/**
 * Sets the page information in the global `window.stjude.digitalData` object.
 *
 * @param {string} name - The name of the page.
 * @param {string} path - The path of the page.
 * @param {string} [eventCode] - Optional event code associated with the page.
 * @return {void}
 */
export function SetPage(name, path, eventCode = "") {
  UpdateUserData();
  window.stjude.digitalData.page = {
    pageName: name,
    path,
    eventCode: eventCode && eventCode.length > 0 ? eventCode : undefined,
  };
}

export function ClearPage() {
  window.stjude.digitalData.page = {};
}

/**
 * Updates the user data stored in `stjude.digitalData.user` with values
 * retrieved from the browser's localStorage.
 *
 * The function fetches the following keys from localStorage:
 * - `tiltifyUsername`: The username associated with the Tiltify account.
 * - `tiltifyCampaignName`: The campaign name associated with the Tiltify account.
 * - `twitchUsername`: The username associated with the Twitch account.
 *
 * If any of these keys do not exist in localStorage, their corresponding values
 * will be set to `null`.
 *
 * The user data is then used to update the `stjude.digitalData.user` object.
 * Specifically, it sets the properties:
 * - `userName`
 * - `userCampaign`
 * - `userTwitchname`
 *
 * Example usage:
 * ```
 * UpdateUserData();
 * ```
 *
 * @function
 */
export function UpdateUserData() {
  const userName = localStorage.getItem("tiltifyUsername") ?? null;
  const userCampaign = localStorage.getItem("tiltifyCampaignName") ?? null;
  const userTwitchname = localStorage.getItem("twitchUsername") ?? null;

  stjude.digitalData.user.userName = userName;
  stjude.digitalData.user.userCampaign = userCampaign;

  stjude.digitalData.user = {
    userName,
    userCampaign,
    userTwitchname,
  };
}
